import { jsx as _jsx } from "react/jsx-runtime";
import Grid from '@mui/material/Grid';
import { Loader } from './loader';
export function AppLoading() {
    return (_jsx(Grid, { alignItems: "center", container: true, flex: 1, justifyContent: "center", width: "100%", children: _jsx(Grid, { children: _jsx(Loader, { size: 100 }) }) }));
}
